export default __webpack_public_path__ + "static/media/text-allign-justify.7157f2c5.svg";